export default {
  MissingInformationDialog__BUTTON_GROUP_ARIA_NEXT: "Next",
  MissingInformationDialog__BUTTON_GROUP_ARIA_PREVIOUS: "Previous",
  MissingInformationDialog__CANCEL: "Cancel",
  MissingInformationDialog__CORRECT: "Yes, this is correct",
  MissingInformationDialog__OKAY: "Okay",
  MissingInformationDialog__RETURN_TO_LOGIN: "No, return to login",
  MissingInformationDialog__SAVE: "Save",
  MissingInformationDialog__SERVICE_NOT_AVAILABLE:
    "Service unavailable at this time, please try again later.",
  MissingInformationDialog__USERNAME_NOT_AVAILABLE: "Sorry, already taken.",
};
